import { Tenant } from "./tenant";

export abstract class TenantRepository {
  createNewTenantAndTrialUserFromTemplate: (
    channelTemplateId: number,
    channelName: string,
    activateChannel: boolean,
    request: RequestDemoData,
  ) => Promise<void>;

  getAll: () => Promise<Array<Tenant>>;

  create: (name: string) => Promise<Tenant>;

  getTenantMediasLanguages: () => Promise<[{ code: string; name: string }]>;
}

export class RequestDemoData {
  personalDetails: PersonalDetails = new PersonalDetails();
  customerDetails: CustomerDetails = new CustomerDetails();
  channelsDetails: ChannelsDetails = new ChannelsDetails();
}

export class PersonalDetails {
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  phone: string = "";
  password: string = "";
  confirmPassword: string = "";
}

export class CustomerDetails {
  companyName: string = "";
  title: string = "";
  countryId: number = -1; //Select Country text
  industry: string = "";
}

export class ChannelsDetails {
  broadcastingChannels: number = 1;
  channelsToLaunch: number = 1;
  channelResolution: string = "";
  audioLanguagesInChannels: Array<any> = [];
  subtitlesLanguagesInChannels: Array<any> = [];
}
